module.exports = __webpack_public_path__ + "img/051.8832002c.png";